const doc = [({"en":({"js":({"admin":({"call_lists":({"show":({"table":({"the_call_list_entity_was_deleted":"This number was deleted"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;